import React from 'react';

const ValidErrorMarker = ({ showMarker }: { showMarker: boolean }): JSX.Element => {
    return <span className={`component-valid-error-marker ${showMarker ? 'show-marker' : ''}`}>&#9679;</span>;
};
export default ValidErrorMarker;
